import Hamburger from "hamburger-react";
import { t } from "i18next";
import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../App";
import logo from "../../assets/images/logo-white.svg";
import menuCloseIcon from "../../assets/images/menu-close.svg";
import { MainMenuItems } from "./main-menu-items";

export function MainMenu() {
    const location = useLocation();
    const { pathname } = location;
    const navigate = useNavigate();

    const [isMainMenuOpen, setMainMenuOpen] = useState(false);
    const { userProfile } = useContext(UserContext);

    const handleClose = () => {
        setMainMenuOpen(false);
    }

    const closeMenu = (event: any) => {
        event.preventDefault();
        setMainMenuOpen(false);
    }

    const handleLogout = (event: any) => {
        event.preventDefault();
        localStorage.removeItem('token');
        navigate("/");
        window.location.reload();
    }

    return (
        <div className="main-menu">
            <Hamburger toggled={isMainMenuOpen} toggle={setMainMenuOpen} />
            { isMainMenuOpen &&
                <div className="main-menu-offcanvas">
                    <div className="background-layer">
                        <div className="main-menu-inner">
                            <a href="#" className="close" title={ t("Close")} onClick={ closeMenu }>
                                <img src={ menuCloseIcon} alt={ t("Close")} />
                            </a>
                            <div className="logo">
                                <img src={ logo } title="Paddletech" />
                            </div>
                            <MainMenuItems close={ handleClose } />
                            <div className="menu-footer">
                                <a href="#" onClick={ handleLogout } title={ t('exit') }>{ t('exit') }</a>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}
